import { useState } from 'react';
import { Trans } from 'react-i18next';
import {
    HorizontalFlex,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    PadContainer,
    VerticalFlex,
} from 'smartsuite-ui';

function Footer() {
    const [isPrivacyPolicyOpen, setIsPrivacyPolicyOpen] = useState(false);

    return (
        <footer className="app-wrapper__footer">
            <VerticalFlex>
                <span className="app-wrapper__footer-content">
                    <Trans
                        i18nKey={'appFooter'}
                        components={[
                            // eslint-disable-next-line jsx-a11y/anchor-has-content
                            <a href="mailto:bcsupport@bagcheck.com" />,
                            // eslint-disable-next-line jsx-a11y/anchor-has-content
                            <a href="tel:+14075057443" />,
                        ]}
                    />
                </span>
                <PadContainer cssClassModifiers={['pad-small']} />
                <HorizontalFlex cssClassModifiers={['justify-center']}>
                    <button
                        className="button-link"
                        type="button"
                        onClick={() => setIsPrivacyPolicyOpen(true)}
                    >
                        Privacy Policy
                    </button>
                </HorizontalFlex>
            </VerticalFlex>
            {isPrivacyPolicyOpen && (
                <Modal onOverlayClick={() => setIsPrivacyPolicyOpen(false)}>
                    <ModalHeader
                        onDismiss={() => setIsPrivacyPolicyOpen(false)}
                    >
                        Privacy Policy
                    </ModalHeader>
                    <ModalBody>
                        No mobile information will be shared with third
                        parties/affiliates for marketing/promotional purposes.
                        All other categories exclude text messaging originator
                        opt-in data and consent; this information will not be
                        shared with any third parties.
                    </ModalBody>
                </Modal>
            )}
        </footer>
    );
}

export default Footer;
